import * as api from '../api';
import { RECEIVE_MANUFACTURERS } from '../constants/action-types';

export const getManufacturers = () => dispatch => {
  api.getManufacturers().then(manufacturers => {
      dispatch(receiveManufacturers(manufacturers));
      return manufacturers;
  })
}

export const receiveManufacturers = manufacturers => ({
  type: RECEIVE_MANUFACTURERS,
  manufacturers
});